import { useContext } from 'react';
import { Navigate } from 'react-router-dom';

import { RegistrationStatusEnum, UserTypeEnum } from '../api';
import { SessionContext } from '../app/contexts/SessionContext';

export const HomeRedirect = () => {
  const { user } = useContext(SessionContext);

  if (!user) {
    return <Navigate to="/" />;
  }

  if (user.user_type === UserTypeEnum.PROVIDER) {
    if (
      user.registration_status === RegistrationStatusEnum.PROVIDER_PROFILE ||
      user.registration_status === RegistrationStatusEnum.PROVISIONAL
    ) {
      window.location.href = '/app/provider/onboarding';
      return;
    }

    return <Navigate to="/app/provider/home" />;
  }

  if (user.user_type === UserTypeEnum.HEALTHCARE_ENTITY_REP) {
    return <Navigate to="/app/healthcare-entity/providers" />;
  }

  return <Navigate to="/" />;
};
